import { useContext } from 'react';
import { ToggleTabsCtx } from './ToggleTabs';
export function useToggleTabs() {
    const ctx = useContext(ToggleTabsCtx);
    if (!ctx) {
        throw new Error('useToggleTabs must be used as a child to <ToggleTabs />');
    }
    return ctx;
}
